export default class Config {
  slideshowId;
  logoUrl;
  frontColumns;
  backColumns;
  cartColumns;
  screensaverUrls;
  screensaverIdle;
  screensaverTransition;
  tileColumns;
  filterColumns;
  productPromotion;
  showPromoProductUpc;
  checkoutMethod;
  loginCustomMessage;
  showCheckoutMemo;

  constructor(configWire, columnById) {
    this.slideshowId = configWire.avenue_config_dto_slideshow_id;
    this.logoUrl = configWire.avenue_config_dto_logo_url;
    this.frontColumns = configWire.avenue_config_dto_front_columns.map(id => columnById[id]);
    this.backColumns = configWire.avenue_config_dto_back_columns.map(id => columnById[id]);
    this.cartColumns = configWire.avenue_config_dto_cart_columns.map(id => columnById[id]);
    this.screensaverUrls = configWire.avenue_config_dto_screensaver_urls;
    this.screensaverIdle = configWire.avenue_config_dto_screensaver_idle_seconds;
    this.screensaverTransition = configWire.avenue_config_dto_screensaver_transition_seconds;
    this.tileColumns = configWire.avenue_config_dto_tile_columns.map(id => columnById[id]);
    this.filterColumns = configWire.avenue_config_dto_filter_columns.map(id => columnById[id]);
    this.productPromotion = configWire.avenue_config_dto_product_promotion;
    this.showPromoProductUpc = configWire.avenue_config_dto_show_promo_product_upc;
    this.checkoutMethod = configWire.avenue_config_dto_checkout_method;
    this.loginCustomMessage = configWire.avenue_config_dto_login_custom_message;
    this.showCheckoutMemo = configWire.avenue_config_dto_show_checkout_memo;
  }
}
